"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var FirebaseUtils_1 = require("./../../firebase/FirebaseUtils");
var Future_1 = require("../../../utils/Future");
var UserCache_1 = require("./../../UserCache");
var CoreServiceHelper_1 = require("../airabbi/CoreServiceHelper");
var HistoryProviderImpl = (function () {
    function HistoryProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " NotificationServiceImpl#")], args, false));
            }
        };
        this.log('HistoryProviderImpl# created!');
    }
    HistoryProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    HistoryProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    HistoryProviderImpl.prototype.getHistories = function (filter) {
        if (!filter || filter.path.indexOf('history') === -1) {
            return Promise.reject('filter cannot be empty!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)(filter.path)
            .then(function (data) {
            future.resolve(data.val());
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    HistoryProviderImpl.prototype.stopAllMonitor = function () {
    };
    HistoryProviderImpl.prototype.createEvent = function (title, content) {
        var _this = this;
        var user = (0, UserCache_1.loadUser)();
        if (!user) {
            this.log('createEvent# user not exist!');
        }
        var event = {
            user: user
                ? {
                    uid: user.uid,
                    email: user.email,
                    name: user.displayName,
                    role: user.role ? user.role : '',
                    unit: user.unit ? user.unit : ''
                }
                : '',
            env: this.env,
            title: title,
            content: content
        };
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .sendEvent(event)
            .then(function () {
            _this.log('sendEvent successfully!');
        })
            .catch(function (err) {
            _this.log('sendEvent# error', err);
        });
    };
    return HistoryProviderImpl;
}());
exports.HistoryProviderImpl = HistoryProviderImpl;
//# sourceMappingURL=HistoryProviderImpl.js.map